import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { mainModule } from 'process';
import { finalize, share, tap } from 'rxjs/operators';
import dayjs from 'dayjs';

@Injectable()
export class QuizService {
  //---------------- Properties---------------
  public baseUrl = '';
 // readonly baseUrl = 'http://localhost:4200';
 public apiUrl = '';
  //readonly apiUrl = 'https://rwtpl.com/online-exam/admin/';

  private cache ={};
  private cachedObservable: Observable<any>;

  public timeData = new Subject<any>();

  public registerTestData = new Subject<any>();
  public registerTestOuterData = new Subject<any>();

  private subject = new Subject<any>();
  private subButtonHandler = new Subject<any>();

  public deviceOrientation = new Subject<any>();

  private successButtonHandler = new Subject<any>();
  
  public $cartCountData = new Subject<any>();
  public $cartData = new Subject<any>();

  TotNotVisited:number = 0;
  TotAnswered:number  = 0;
  TotNotAnswered:number  = 0;
  ToMarked:number  = 0;
  savedAns = [];
  seconds: number = 0;
  section_seconds: number = 0;
  question_seconds: number = 0;
  sectionTime:number = 0;
  timer;
  section_timer;
  question_timer;
  totTime:number;

  notSavedQid = [];
  savedQid = [];
  markedQid = [];
  onlyMarkedQid = [];


  // my new impl
  answeredOnly = [];
  markedAndReviewed = [];
  markedOnly = [];
  notAnswered = [];

 testSeriesQuestionAnswerMap = new Map();
 testSeriesQuesAnsObj = {};

 customerId = '';
 linkToAllow=[];
 restrictUnPaidUserModules=[];
 isZoneEnabled=false;
 priorityIdsList=[];
 prioritySlugList=[];

 userData:any;
 mainBaseUrl:any;
 rootUrl='';

 userId=0;

  //---------------- Helper Methods---------------
  constructor(
    private http: HttpClient,
    private router: Router,
    private config: AppConfig
  ) {
    this.baseUrl = this.config.getConfig('BASEURL');
    this.apiUrl = this.config.getConfig('API_URL');
    this.rootUrl = this.config.getConfig('ROOT_URL');
    this.customerId = this.config.getConfig('CUSTOMER_ID');
    this.linkToAllow = this.config.getConfig('MODULES_TO_ALLOW_AFTER_LOGIN');
    this.restrictUnPaidUserModules = this.config.getConfig('MODULES_TO_RESTRICT_FOR_UN_PAID_USERS');
    this.isZoneEnabled = this.config.getConfig('IS_ZONE_ENABLED');

    if(localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }

  }

  setUserData() {
    if(localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
  }

  setCustomFieldsData() {
    this.baseUrl = this.config.getConfig('BASEURL');
    this.apiUrl = this.config.getConfig('API_URL');
    this.customerId = this.config.getConfig('CUSTOMER_ID');
    this.linkToAllow = this.config.getConfig('MODULES_TO_ALLOW_AFTER_LOGIN');
    this.restrictUnPaidUserModules = this.config.getConfig('MODULES_TO_RESTRICT_FOR_UN_PAID_USERS');
    this.isZoneEnabled = this.config.getConfig('IS_ZONE_ENABLED');
  }

  loadScriptSync (src) {
    var s = document.createElement('script');
    s.src = src;
    s.type = "text/javascript";
    s.async = false;                                 // <-- this is important
    document.getElementsByTagName('head')[0].appendChild(s);
}

  sendRazorPayData(orderData) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    this.subject.next({ orderData });
  }

  cacheAPI(url): Observable<any> {
    let observable: Observable<any>;
    if (this.cache && this.cache[url]) {
      observable = of(this.cache[url]);
    } else {
      this.cachedObservable = this.http.get<any>(url)
        .pipe(
          tap(res => this.cache[url] = res),
          share(),
          finalize(() => this.cachedObservable = null)
        );
      observable = this.cachedObservable;
    }
    return observable;
  }


  filterPackageData(catIds, data, filterItem, toInclude =0, packageFilterItem='package_id', toPackageFilter=0) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    if(data && data.length > 0) {
      if(toInclude) {
          data = data.filter(item => {
            return catIds.includes(item[filterItem]+'');
        });
      } else {
        if(this.config.getConfig('CATEGORIES_TO_INCLUDE')) {
          data = data.filter(item => {
              return catIds.includes(item[filterItem]+'');
          });
        } else {
          data = data.filter(item => {
              return !catIds.includes(item[filterItem]+'');
          });
        }
      }

      if(this.config.getConfig('PACKAGES_TO_FILTER') && toPackageFilter) {
        if(this.config.getConfig('PACKAGES_TO_INCLUDE')) {
          data = data.filter(item => {
              return this.config.getConfig('PACKAGES_TO_FILTER').includes(item[packageFilterItem]+'');
          });
        } else {
          data = data.filter(item => {
              return !this.config.getConfig('PACKAGES_TO_FILTER').includes(item[packageFilterItem]+'');
          });
        }
      }
    }
    return data;
  }

  async sequenceByPriority(packageData, keyToCompare, orderByCatId) {
    var data = packageData;
    var order = {};
    if(this.config.getConfig('SEQUENCE_BY_PRIORITY')) {
        if(this.priorityIdsList && this.priorityIdsList.length == 0) {
          var response = await this.getSubCat();
          if(response && response['data']) {
            response['data'].forEach(subcat => {
              this.priorityIdsList.push(subcat.cat_id);
              this.prioritySlugList.push(subcat.cat_slug);
            })
          }
        }
        if(orderByCatId) {
          this.priorityIdsList.forEach(function (a, i) { order[a] = i; });
        } else {
          this.prioritySlugList.forEach(function (a, i) { order[a] = i; });
        }
       }
       if(Object.keys(order).length > 0)
        data.sort(function (a, b) {
          return order[a[keyToCompare]] - order[b[keyToCompare]];
         });
         return data;
  }


  async getSubCat() {
    let res = await this.cacheAPI(this.apiUrl + 'api/sub-categories/'+this.customerId).toPromise();
    return res;
  }

  getPlansCatSlug(subCat, key, val) {
    var obj = {
      "category" : '0',
      "catSlug" : 'all',
      "catName": 'all'
    }
    val = val+'';
    val = val.replace(/%20/g,' ');
    if(subCat && subCat.length>0) {
      subCat.forEach(subcat => {
        if(subcat[key] == val+'') {
          obj['category'] = subcat['cat_id'];
          obj['catSlug'] = subcat['cat_slug'];
          obj['catName'] = subcat['cat_name'];
        }
      })
    }
    return obj;
  }

  formatBytes(bytes) {
    var decimals = 2;
    if(bytes === 0) return '';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PM', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  convertToInternationalCurrencySystem (labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

    ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
    // Six Zeroes for Millions
    : Math.abs(Number(labelValue)) >= 1.0e+6

    ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
    // Three Zeroes for Thousands
    : Math.abs(Number(labelValue)) >= 1.0e+3

    ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"

    : Math.abs(Number(labelValue))+"";

}

// To get pretty datetime format
getFormattedDate = (value: any, dateFormat: string) => {
  // Input	Example	Description
  // YY	01	Two-digit year
  // YYYY	2001	Four-digit year
  // M	1-12	Month, beginning at 1
  // MM	01-12	Month, 2-digits
  // MMM	Jan-Dec	The abbreviated month name
  // MMMM	January-December	The full month name
  // D	1-31	Day of month
  // DD	01-31	Day of month, 2-digits
  // H	0-23	Hours
  // HH	00-23	Hours, 2-digits
  // h	1-12	Hours, 12-hour clock
  // hh	01-12	Hours, 12-hour clock, 2-digits
  // m	0-59	Minutes
  // mm	00-59	Minutes, 2-digits
  // s	0-59	Seconds
  // ss	00-59	Seconds, 2-digits
  // S	0-9	Hundreds of milliseconds, 1-digit
  // SS	00-99	Tens of milliseconds, 2-digits
  // SSS	000-999	Milliseconds, 3-digits
  // Z	-05:00	Offset from UTC
  // ZZ	-0500	Compact offset from UTC, 2-digits
  // A	AM PM	Post or ante meridiem, upper-case
  // a	am pm	Post or ante meridiem, lower-case
  // Do	1st... 31st	Day of Month with ordinal
  // X	1410715640.579	Unix timestamp
  // x	1410715640579	Unix ms timestamp

  return dayjs(value).format(dateFormat);
}

compareDates = (d1: any, d2: any, threshold: any) => {
  var date1: any = new Date(d1);
  var date2: any = new Date(d2);
  if (date1 != 'Invalid Date' && date2 != 'Invalid Date') {
    if (threshold) {
      if ((date2.valueOf() - date1.valueOf()) > threshold) {
        return true;
      } else {
        return false;
      }
    } else {
      return (date2.valueOf() - date1.valueOf());
    }
  } else {
    return false;
  }
}

addTimeToDate = (dt:any, hr:number, min: number, sec:number, eod?: boolean, eot?: boolean ) => {
  var date: any = new Date(dt);
  date.setHours(date.getHours()+ +hr);
  date.setMinutes(date.getMinutes()+ +min);
  date.setSeconds(date.getSeconds()+ +sec);
  if(eot) {
    date.setSeconds(60);
  }
  return date;
}

addDaysToDate = (dt:any, days:number,  months: number, years:number,  eod?: boolean, eot?: boolean ) => {
  var date: any = new Date(dt);
  date.setDate(date.getDate()+ +days);
  date.setMonth(date.getMonth()+ +months);
  date.setFullYear(date.getFullYear()+ +years);
  if(eot) {
    date.setSeconds(60);
  }
  return date;
}

getEncodedURL(url) {
  url = encodeURIComponent(url);
  url = url.replace(/\(/g, '%28');
  url = url.replace(/\)/g, '%29');
  return url+'';
}

getDencodeURL(url) {
  url = url.replace(/%29/g, ')');
  url = url.replace(/%28/g, '(');
  url = decodeURIComponent(url);
  return url+'';
}

getFirstNChars(base64str, count) {
  if(base64str && base64str.length > count) {
    return base64str.slice(0, count);
  } else {
    return base64str;
  }
 }

customBlobEncryptText(text) {
  function generateRandomDigits(length) {
    let result = '';
    const digits = '0123456789qwertyuiopasdfghjklzxcvbnm';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * digits.length);
      result += digits.charAt(randomIndex);
    }
    return result;
  }
  var ckey = generateRandomDigits(1);
  var finalData = text;
  finalData = finalData.split('').reverse().join('');
  finalData = btoa(finalData);
  var flen = finalData.length/2;
  finalData = ckey + finalData.substring(0,flen) + ckey + finalData.substring(flen,finalData.length);
  finalData = btoa(finalData);
  var dummyKey = generateRandomDigits(24);
  dummyKey = dummyKey.substring(0,10) + ckey + dummyKey.substring(10,25);
  dummyKey = btoa(dummyKey);
  var finalResult = {
    key: dummyKey,
    result: finalData
  };
  return finalResult;

}

customBlobDecryptText(token) {
 var finalUrl = atob(token);
 var urllen = finalUrl.length/2;
 finalUrl = finalUrl.substring(1,urllen) + finalUrl.substring(urllen+1,finalUrl.length);
 finalUrl = atob(finalUrl);
 finalUrl = finalUrl.split('').reverse().join('');
 return finalUrl;
}

encryptText(text) {
  return text.charAt(3)+text.charAt(1)+ text.charAt(3)+text.split("").reverse().join("") + text + text.split("").reverse().join("")+ text.charAt(2);
}

decryptText(encText) {
  var decryptText = encText.slice(3,encText.length-1);
  decryptText = decryptText.substring(decryptText.length/3,(decryptText.length/3)*2);
  return decryptText
}

extractFileNameFromList(fileList: any[], key: string, keyToSave: string) {
  if (fileList && fileList.length) {
    fileList.forEach(((fileObj: any) => {
      if (fileObj && fileObj[key]) {
        fileObj[keyToSave] = this.extractFileName(fileObj[key]);
      }
    }))
  }
}

extractFileName(filePath: string){
  var fileName = '';
  if (filePath) {
    var fPath = filePath.split('/');
    if (fPath && fPath.length) {
      fileName = fPath[fPath.length - 1];
    }
  }
  return fileName;
}

filterCourseDetailsObject(courses: any[], id: string) {
  var finalCourse: any = {};
  if (courses && courses.length) {
    finalCourse = courses.filter((course: any) => {
      if (course.id == id) {
        return true
      } else {
        return false;
      }
    })
  }
  if (finalCourse && finalCourse.length > 0) {
    return finalCourse[0];
  } else {
    return {};
  }
}

decodeVideoUrlFromList = (videoList: any[], key: string, enableEmbedUrl: boolean, skipEncryption: boolean) => {
  if (videoList && videoList.length) {
    videoList.forEach((video: any) => {
      this.decodeVideoUrl(video, key, enableEmbedUrl, skipEncryption);
    });
  }
}

decodeVideoUrl(video: any, key: string, enableEmbedUrl: boolean, skipEncryption: boolean){
  if (video[key]) {
    if (video[key].indexOf('youtu.be/') != -1) {
      var urlsplit = video[key].split('youtu.be/');
      if (urlsplit && urlsplit.length > 1) {
        if (skipEncryption) {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
        } else {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = this.encryptVideoLink(video[key]);
        }
        if (enableEmbedUrl) {
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = 'https://www.youtube.com/embed/' + video[key];
        }
      }
    } else if (video[key].indexOf('youtube.com/watch?v=') != -1) {
      var urlsplit = video[key].split('youtube.com/watch?v=');
      if (urlsplit && urlsplit.length > 1) {
        if (skipEncryption) {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
        } else {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = this.encryptVideoLink(video[key]);
        }
        if (enableEmbedUrl) {
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = 'https://www.youtube.com/embed/' + video[key];
        }
      }
    } else if (video[key].indexOf('youtube.com/embed/') != -1) {
      var urlsplit = video[key].split('youtube.com/embed/');
      if (urlsplit && urlsplit.length > 1) {
        if (skipEncryption) {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
        } else {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = this.encryptVideoLink(video[key]);
        }
        if (enableEmbedUrl) {
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = 'https://www.youtube.com/embed/' + video[key];
        }
      }
    } else if (video[key].indexOf('youtube.com/live/') != -1) {
      var urlsplit = video[key].split('youtube.com/live/');
      if (urlsplit && urlsplit.length > 1) {
        if (skipEncryption) {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
        } else {
          video[key] = urlsplit[1];
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = this.encryptVideoLink(video[key]);
        }
        if (enableEmbedUrl) {
          if(video[key] && video[key].indexOf('?') != -1) {
            video[key] = video[key].split('?')[0];
          }
          video[key] = 'https://www.youtube.com/embed/' + video[key];
        }
      }
    }
  }
}

encryptVideoLink(text: string){
  return text.charAt(3) + text.charAt(1) + text.charAt(3) + text.split("").reverse().join("") + text + text.split("").reverse().join("") + text.charAt(2);
}

decryptVideoLink(encText: string){
  var decryptText = encText.slice(3, encText.length - 1);
  decryptText = decryptText.substring(decryptText.length / 3, (decryptText.length / 3) * 2);
  return decryptText
}

courseNameModify(courseList:any) {
  // if(courseList && courseList.length) {
  //   courseList.forEach((course:any) => {
  //     if(course.title){
  //       course.title = course.title.toLowerCase();
  //     }
  //   })
  // }
}


daysDiffCalculator(date1, date2) {
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Math.round(Difference_In_Days);
}


getRazorPaydata(): Observable<any> {
  if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
  return this.subject.asObservable();
}

setSubButtonHandler(check) {
  if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
  this.subButtonHandler.next({ check });
}

getSubButtonHandler(): Observable<any> {
  if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
  return this.subButtonHandler.asObservable();
}

setSuccessButtonHandler(issuccess) {
  if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
  this.successButtonHandler.next({ 'issuccess': 1 });
}

getSuccessButtonHandler(): Observable<any> {
  if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
  return this.successButtonHandler.asObservable();
}

fetchPDFData = async(url) => {
  const response = await fetch(url);
  const data = await response.blob();
  return data;
}

reverseStringFn(str) {
  return str.split('').reverse().join('');
}

decodeSecuredPDFdata = async(pdfUrl) => {
  var finalData:any = {};
      const pdfBlob = await this.fetchPDFData(pdfUrl);
      try {
        var base64String:any = await this.blobToBase64(pdfBlob);
        let firstnchars = base64String.substr(0, 20);
        let reverseString = this.reverseStringFn(firstnchars);
        let lastChar = reverseString.substr(19, 1);
        let customCharValue = lastChar.charCodeAt(0);
        reverseString = reverseString.substr(0, 10);
        let nextchars = base64String.substr(20 + customCharValue, base64String.length);
        let finalChars = reverseString + nextchars;
        // if(finalChars && finalChars.indexOf('gc=') == -1) {
        //   finalChars = finalChars + 'gc=';
        // }
        // decode base64 string, remove space for IE compatibility
        var binary = atob(finalChars.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        var finalblob = new Blob([view], {type: "application/pdf"});
        const finalBlobUrl = URL.createObjectURL(finalblob);
        finalData['finalBlobUrl'] = finalBlobUrl;
        var pdfurlname;
        pdfurlname = finalBlobUrl.split('/');
        if(pdfurlname && pdfurlname.length) {
          pdfurlname= pdfurlname[pdfurlname.length-1]
        } else {
          pdfurlname = 'notvalid';
        }
        var tokenUrl = '';
        var secretkey = '';
        var encData = this.customBlobEncryptText(pdfurlname);
        secretkey = encData['key'];
        tokenUrl = encData['result'];
        tokenUrl = encodeURIComponent(tokenUrl);
        secretkey = encodeURIComponent(secretkey);
        finalData['secretkey'] = secretkey;
        finalData['tokenUrl'] = tokenUrl;
      } catch (error) {
        console.error('Error converting Blob to base64:', error);
      }
      return finalData;
}


blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        const base64String = result.split(',')[1]; // Extract base64 portion
        resolve(base64String);
      } else {
        reject(new Error('Unexpected result type from FileReader'));
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(blob);
  });
}

public setCartCountData(data) {
  this.$cartCountData.next(data);
}

public getCartCountData() {
  return this.$cartCountData.asObservable();
}

public setExistingCartData(data) {
  this.$cartData.next(data);
}

public getExistingCartData() {
  return this.$cartData.asObservable();
}


  getCompleteTimer(seconds) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var leftover = seconds;
    var hours = Math.floor(leftover / 3600);

    //how many seconds are left
    leftover = leftover - (hours * 3600);

    //how many minutes fits in the amount of leftover seconds
    var minutes = Math.floor(leftover / 60);

    //how many seconds are left
    leftover = leftover - (minutes * 60);

    return  (hours > 0 ? "0"+ hours +":": '00:')+(minutes < 10 ? '0'+minutes : minutes)+":"+(leftover < 10 ? '0'+leftover : leftover);
  }

  getSectionTimer(section_seconds) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var leftover = section_seconds;
    var hours = Math.floor(leftover / 3600);

    //how many seconds are left
    leftover = leftover - (hours * 3600);

    //how many minutes fits in the amount of leftover seconds
    var minutes = Math.floor(leftover / 60);

    //how many seconds are left
    leftover = leftover - (minutes * 60);

    return  (hours > 0 ? "0"+hours +":": '00:')+(minutes < 10 ? '0'+minutes : minutes)+":"+(leftover < 10 ? '0'+leftover : leftover);
  }

  getQuestionTimer() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var leftover = this.question_seconds;
    var hours = Math.floor(leftover / 3600);

    //how many seconds are left
    leftover = leftover - (hours * 3600);

    //how many minutes fits in the amount of leftover seconds
    var minutes = Math.floor(leftover / 60);

    //how many seconds are left
    leftover = leftover - (minutes * 60);

    return (hours > 0 ? hours +":": '')+(minutes < 10 ? '0'+minutes : minutes)+":"+(leftover < 10 ? '0'+leftover : leftover);
  }


  saveAnsweredData(allAnsData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('quizData', JSON.stringify(allAnsData));
  }

  getAnsweredData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('quizData'));
  }

  removeAnsweredData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("quizData");
  }

  saveNotAnsweredData(allNotAnsData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('notAnsData', JSON.stringify(allNotAnsData));
  }

  getNotAnsweredData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('notAnsData'));
  }

  removeNotAnsweredData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("notAnsData");
  }

  saveMarkedReviewData(mrData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('markReviewData', JSON.stringify(mrData));
  }

  getMarkedReviewData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('markReviewData'));
  }

  removeMarkedReviewData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("markReviewData");
  }


  saveIsAnsweredSavedMap(mrData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('isAnsSaved', JSON.stringify(mrData));
  }

  getIsAnsweredSavedMap(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('isAnsSaved'));
  }

  removeIsAnsweredSavedMap(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("isAnsSaved");
  }


  getSavedQuesData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('savedQuestionData'));
  }

  saveQuesData(qsData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('savedQuestionData', JSON.stringify(qsData));
  }

  removeQuesData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("markReviewData");
  }

  saveMarkedDataOnly(mrData){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('markData', JSON.stringify(mrData));
  }

  getMarkedDataOnly(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('markData'));
  }

  removeMarkedDataOnly(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("markData");
  }

  // new impl
  getAnsweredOnlyNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('quizData1'));
  }

  removeAnsweredOnlyNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("quizData1");
  }

  saveAnsweredOnlyNew(answeredOnly){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('quizData1', JSON.stringify(answeredOnly));
  }

  getNotAnsweredNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('notAns1'));
  }

  removeNotAnsweredNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("notAns1");
  }

  saveNotAnsweredNew(markedAndReviewed){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('notAns1', JSON.stringify(markedAndReviewed));
  }

  getMarkedAndReviewedNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('markAndAns1'));
  }

  removeMarkedAndReviewedNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("markAndAns1");
  }

  saveMarkedAndReviewedNew(markedAndReviewed){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('markAndAns1', JSON.stringify(markedAndReviewed));
  }

  getMarkedOnlyNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('mark1'));
  }

  removeMarkedOnlyNew(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("mark1");
  }

  saveMarkedOnlyNew(markedOnly){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('mark1', JSON.stringify(markedOnly));
  }

  getQuesAnswersMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('quesAns1'));
  }

  removeQuesAnswersMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("quesAns1");
  }

  saveQuesAnswersMapNew(quesAns) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('quesAns1', JSON.stringify(quesAns));
  }


  getQuesTimerMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('quesTimer1'));
  }

  removeQuesTimerMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("quesTimer1");
  }

  saveQuesTimerMapNew(quesAns) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('quesTimer1', JSON.stringify(quesAns));
  }

  getQuesCustDataMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return JSON.parse(localStorage.getItem('quesCustData1'));
  }

  removeQuesCustDataMapNew() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.removeItem("quesCustData1");
  }

  saveQuesCustDataMapNew(quesAns) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return localStorage.setItem('quesCustData1', JSON.stringify(quesAns));
  }

  clearMapData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    localStorage.removeItem('question_seconds');
    localStorage.removeItem('seconds');
    localStorage.removeItem('section_seconds');
    localStorage.removeItem('isPaused');
    localStorage.removeItem('quesTimer1');
    localStorage.removeItem('quesCustData1');
    this.removeAnsweredOnlyNew();
    this.removeNotAnsweredNew();
    this.removeMarkedAndReviewedNew();
    this.removeMarkedOnlyNew();
    this.removeQuesAnswersMapNew();
  }

  clearTestCacheData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    localStorage.removeItem('isSubmitted');
    localStorage.removeItem('seconds');
    localStorage.removeItem('section_seconds');
    localStorage.removeItem('question_seconds');
    localStorage.removeItem('sectionIndex');
    localStorage.removeItem('quizLang');
    localStorage.removeItem('quizData');
    localStorage.removeItem('notAnsData');
    localStorage.removeItem('markData');
    localStorage.removeItem('markReviewData');
    localStorage.removeItem('savedQuestionData');
    localStorage.removeItem('quizData1');
    localStorage.removeItem('notAns1');
    localStorage.removeItem('markAndAns1');
    localStorage.removeItem('mark1');
    localStorage.removeItem('quesAns1');
    localStorage.removeItem('isAnsSaved');
    localStorage.removeItem('quesTimer1');
    localStorage.removeItem('quesCustData1');
    localStorage.removeItem('isPaused');
}


  //---------------- Http Methods---------------
  getQuestions(testId,language) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //return this.http.get(this.apiUrl + 'api/questions/'+testId+'/'+language);
    return this.cacheAPI(this.apiUrl + 'api/questions/'+testId+'/'+language);
  }

  getQuestionsAns(testId,language) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/questions-ans/'+testId+'/'+language);
   return this.cacheAPI(this.apiUrl + 'api/questions-ans/'+testId+'/'+language);
  }

  getQuestionsCount(sec_id,series_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/questions-count/'+sec_id+'/'+series_id);
    return this.cacheAPI(this.apiUrl + 'api/questions-count/'+sec_id+'/'+series_id);
  }

  saveResult(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-result/', data);
  }

  saveTestResult(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-result-new/', data);
  }

  getSeriesAnswer(user_id, series_id, count=1){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/get-result/'+user_id+'/'+series_id+ '/'+count);
    // return this.http.get(this.apiUrl + 'api/get-result/'+user_id+'/'+series_id+ '/'+count);
  }

  getStrengthsWeaknessesData(user_id, series_id, count=1){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-strengths-weaknesses/'+user_id+'/'+series_id);
    return this.cacheAPI(this.apiUrl + 'api/get-strengths-weaknesses/'+user_id+'/'+series_id+ '/'+count);
  }

  getUserAttemptExam(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/attempted-data/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/attempted-data/'+user_id);
  }

  getUserRankData(user_id, series_id, zoneId='', count=1){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/rank-data/'+user_id+'/'+series_id);
    if(this.isZoneEnabled) {
      return this.cacheAPI(this.apiUrl + 'api/rank-data-by-zone/'+user_id+'/'+series_id+'/'+zoneId+'/'+count);
    } else {
      return this.cacheAPI(this.apiUrl + 'api/rank-data/'+user_id+'/'+series_id+'/'+count);
    }
  }

  getAllToppersData(series_id, zoneId=''){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/all-toppers/'+series_id+'/'+this.customerId);
  if(this.isZoneEnabled) {
    return this.cacheAPI(this.apiUrl + 'api/all-toppers-by-zone/'+series_id+'/'+this.customerId+'/'+zoneId);
  } else {
    return this.cacheAPI(this.apiUrl + 'api/all-toppers/'+series_id+'/'+this.customerId);
  }
  }

  getSeriesData(){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/free-series');
    return this.cacheAPI(this.apiUrl + 'api/free-series');
  }

  getInstruction(series_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/instructions/'+series_id);
    return this.cacheAPI(this.apiUrl + 'api/instructions/'+series_id);
  }

  getUserResult(user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/users-tests/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/users-tests/'+user_id);
  }

  getAnswers(user_id, series_id, count=1){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/user-solution-new/'+user_id+'/'+series_id);
    return this.cacheAPI(this.apiUrl + 'api/user-solution-new/'+user_id+'/'+series_id+ '/'+ count);
  }

  getHomeSeriesData(type, cat_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/home-series/'+type+'/'+cat_id);
    return this.cacheAPI(this.apiUrl + 'api/home-series/'+type+'/'+cat_id);
  }

  getHomeSeriesDataNew(type, cat_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/home-series-data/'+type+'/'+cat_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/home-series-data/'+type+'/'+cat_id+'/'+this.customerId);
  }
  getHomeSeriesQuizDataNew(type, cat_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/home-series-data/'+type);
    return this.cacheAPI(this.apiUrl + 'api/home-series-data/'+type);
  }

  getPckageData(type, cat_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/packages/'+type+'/'+cat_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/packages/'+type+'/'+cat_id+'/'+this.customerId);
  }

  getPckageDataNew(type, cat_slug){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/packages-data/'+type+'/' + cat_slug +'/'+this.customerId+'/'+this.userId);
    // if(type == 'test-series') {
    // //  return this.http.get(this.apiUrl + 'api/packages-data/'+type+'/'+cat_slug+'/'+this.customerId);
    //   return this.cacheAPI(this.apiUrl + 'api/packages-data/'+type+'/'+cat_slug+'/'+this.customerId);
    // } else {
    // //  return this.http.get(this.apiUrl + 'api/packages-data/'+type+'/'+cat_slug);
    //   return this.cacheAPI(this.apiUrl + 'api/packages-data/'+type+'/'+cat_slug);
    // }
  }

  getPckageDetails(package_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/package-detail/'+package_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/package-detail/'+package_id+'/'+this.customerId);
  }


  createOrder(body) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/get-razorpay-id', body);
  }


  getRazorPayOrderDetails(paymentId, httpOptions) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get('https://'+this.config.getConfig('RAZORPAY_KEY_ID')+':'+this.config.getConfig('RAZORPAY_KEY_SECRET')+'@api.razorpay.com/v1/payments/'+paymentId);
  }

  sendPaymentIdToServer(payment_Id, bodyData) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/razorpaytest', bodyData);
  }

  checkout(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/checkout-web-new/', data);
  }

  checkoutNewMob(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/checkout-mob-new/', data);
  }

  couponCodeValidate(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/apply-coupon/',data);
  }

  applyCouponToCartData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/apply-coupon-to-cart/',data);
  }

  getQuestionsSolutions(testId,language) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //return this.http.get(this.apiUrl + 'api/questions-solutions-new/'+testId+'/'+language);
    return this.cacheAPI(this.apiUrl + 'api/questions-solutions-new/'+testId+'/'+language);
  }

  reportQuestion(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/report-question/', data);
  }

  getQuesPercantage(series_id, sec_id, question_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //this.timeData.asObservable();
    // this.http.get(this.apiUrl + 'api/question-percantage/' + series_id + '/' + sec_id + '/' + question_id).subscribe(data => {
    //   if (data) {
    //     this.timeData.next(data);
    //   }

    return this.cacheAPI(this.apiUrl + 'api/question-percantage/' + series_id + '/' + sec_id + '/' + question_id).subscribe(data => {
        if (data) {
          data.question_id = series_id + '#' + sec_id + '#' + question_id;
          this.timeData.next(data);
        }

    });

    //return this.http.get(this.apiUrl + 'api/question-percantage/'+series_id+'/'+sec_id+'/'+question_id);
    //return this.http.get(this.apiUrl + 'api/question-percantage/'+series_id+'/'+sec_id);
    //return this.timeData;
  }
  getQuesPercantagebkp(series_id, sec_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/question-percantage/' + series_id + '/' + sec_id);
    return this.cacheAPI(this.apiUrl + 'api/question-percantage/' + series_id + '/' + sec_id);
    //return this.timeData;
  }

  getUserOrder(user_id, package_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/order-history/'+user_id+'/'+package_id);
    return this.cacheAPI(this.apiUrl + 'api/order-history/'+user_id+'/'+package_id);
  }

  getPlansData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   return this.http.get(this.apiUrl + 'api/plans-web/'+this.customerId);
    // return this.cacheAPI(this.apiUrl + 'api/plans-web/'+this.customerId);
  }
  getPlansDataCatWise(userid) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   return this.http.get(this.apiUrl + 'api/getAllSubscriptions/'+this.customerId+'/'+userid);
    // return this.cacheAPI(this.apiUrl + 'api/getAllSubscriptions/'+this.customerId+'/'+userid);
  }

  getAllSubscriptionsCustomerPlans(userid) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getAllSubscriptions/'+this.customerId+'/'+userid);
    return this.cacheAPI(this.apiUrl + 'api/getAllSubscriptionsCustomerPlans/'+this.customerId+'/'+userid);
  }

  getAvgData(series_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //return this.http.get(this.apiUrl + 'api/avg-result/'+series_id);
    //return this.http.get(this.apiUrl + 'api/avg-result-update/'+series_id);

   // return this.http.get(this.apiUrl + 'api/avg-score/'+series_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/avg-score/'+series_id+'/'+this.customerId);
  }

  saveQuestion(data){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-question', data);
  }

  getPackage(series_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/package/'+series_id);
    return this.cacheAPI(this.apiUrl + 'api/package/'+series_id);
  }

  getCategories() {
     if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/sub-categories/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/sub-categories/'+this.customerId);
  }

  getBreadCrumsInitData(breadcrum) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-cat/'+breadcrum);
    return this.cacheAPI(this.apiUrl + 'api/get-cat/'+breadcrum);
  }

  getMenus() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/main-menu/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/main-menu/'+this.customerId);
  }

  getUserPckageData(type, user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/user-package/'+type+'/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/user-package/'+type+'/'+user_id);
  }

  getUserPkgAttemptExam(user_id, pkg_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/user-attempted-data/'+user_id+'/'+pkg_id);
    return this.cacheAPI(this.apiUrl + 'api/user-attempted-data/'+user_id+'/'+pkg_id);
  }

  getUserTestSeriesData(type, user_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/user-series-data/'+type+'/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/user-series-data/'+type+'/'+user_id);
  }

   getAvgRankData(series_id){
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
  }

  savePrcticeResult(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-practice-result', data);
  }


  getRecentAttemptedTests(user_id, start, inc) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-user-series-data-v1/'+user_id+'/'+start+'/'+inc);
    return this.cacheAPI(this.apiUrl + 'api/get-user-series-data-v1/'+user_id+'/'+start+'/'+inc);
  }

  getRecentAttemptedTestsCount(user_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-user-series-data-count-v1/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/get-user-series-data-count-v1/'+user_id);
  }

  getChartUserSeries(user_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-user-series-recent-v1/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/get-user-series-recent-v1/'+user_id);
  }

  getChartUserSeriesTime(user_id) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
  //  return this.http.get(this.apiUrl + 'api/get-user-series-recent-time-v1/'+user_id);
    return this.cacheAPI(this.apiUrl + 'api/get-user-series-recent-time-v1/'+user_id);
  }



  saveUserGuidencePopupData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/saveUserPopUpDetail', data);
  }

  getUserGuidencePopupData(userid) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getUserPopUpDetail/'+userid);
    return this.cacheAPI(this.apiUrl + 'api/getUserPopUpDetail/'+userid);
  }

  getScholarshipData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //return this.http.get(this.apiUrl + 'api/getscholarshipdata');
    return this.cacheAPI(this.apiUrl + 'api/getscholarshipdata');
  }

  getTestDetails(testId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getUserTestDetails/'+testId);
    return this.cacheAPI(this.apiUrl + 'api/getUserTestDetails/'+testId);
  }

  fetchUserRegisteredTestDetails(userId, getFromCache) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    if(getFromCache) {
      return this.cacheAPI(this.apiUrl + 'api/getUserRegisteredTestDetails/'+userId);
    } else {
      return this.http.get(this.apiUrl + 'api/getUserRegisteredTestDetails/'+userId);
    }
  }

  getAttemptedTestByUserId(userId, getFromCache) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    if(getFromCache) {
      return this.cacheAPI(this.apiUrl + 'api/getAttemptedTestByUserId/'+userId);
    } else {
      return this.http.get(this.apiUrl + 'api/getAttemptedTestByUserId/'+userId);
    }
  }

  scholorIsRegisterd(userId, testId, isRegistered) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    let data = {
      user_id: userId+"",
      test_id: testId+"",
      is_registered: 1+""
    };
    return this.http.post(this.apiUrl + 'api/registerUser', data);
  }

  getUserMobileVerificationByUserId(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    //return this.http.get(this.apiUrl + 'api/getUserMobileVerificationByUserId/'+userId);
    return this.cacheAPI(this.apiUrl + 'api/getUserMobileVerificationByUserId/'+userId);
  }

  sentOtp(mobNo) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/sendOtp/'+mobNo);
  }

  verifyOtp(otp, mobNo, userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    if(userId) {
      return this.http.get(this.apiUrl + 'api/verifyOtp/'+otp+'/'+mobNo+'/'+userId);
    } else {
      return this.http.get(this.apiUrl + 'api/verifyOtp/'+otp+'/'+mobNo+'/0');
    }
  }


  isMobRegistered(mobNo) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/isExistMobile/'+mobNo);
  }

  getPackageWisePurchaseHistory(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getPackageWisePurchaseHistory/'+userId);
    return this.cacheAPI(this.apiUrl + 'api/getPackageWisePurchaseHistory/'+userId);
  }

  purchasedEbooks(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/user-ebook/'+ userId);
    return this.cacheAPI(this.apiUrl + 'api/user-ebook/'+ userId);
  }

  downloadFile(ebookName): any {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    const headers= new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');
	   return this.http.get(this.apiUrl + 'assets/ebooks/'+ebookName, { 'headers': headers , responseType: 'blob'});
  }

  getQuizDataByCat(cat) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getQuizDataByCat/'+ cat);
    return this.cacheAPI(this.apiUrl + 'api/getQuizDataByCat/'+ cat);
  }

  getQuizData(catId,userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/getQuizData/'+ catId+'/'+userId);
    return this.cacheAPI(this.apiUrl + 'api/getQuizData/'+ catId+'/'+userId+'/'+ this.customerId);
  }

  getUserEbookNotes(userId, ebookId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-user-ebook-notes/'+ userId+'/'+ebookId);
    return this.cacheAPI(this.apiUrl + 'api/get-user-ebook-notes/'+ userId+'/'+ebookId);
  }
  saveUserEbookNotes(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-user-ebook', data);
  }

  getUserSubscriptionActive(user_id) {
   // return this.http.get(this.apiUrl + 'api/order-history/'+user_id+'/1');
   if(!this.apiUrl) {
    this.setCustomFieldsData();
  }
    return this.cacheAPI(this.apiUrl + 'api/order-history/'+user_id+'/1');
  }

  examPageViewed(data){
    return this.http.post(this.apiUrl + 'api/update-page-data', data);
  }

  examPageShared(data){
    return this.http.post(this.apiUrl + 'api/update-share-data', data);
  }

  getZoneWiseData() {
    return this.cacheAPI('https://mockstree.com/admin/api/get-customer-zones/'+this.customerId);
  }

  getEbooksData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/get-ebooks/'+this.customerId);
  }

  getGalleyImagesData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/get-gallery-images');
  }
  getPublicationsData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/get-publications');
  }

  seriesIdData(package_id, series_id) {
    var formData:any = new FormData();
    formData.append('series_id', series_id);
    formData.append('package_id', package_id);
    return this.http.post(this.apiUrl + 'api/get-series-data-by-seriesid-packageid', formData);
  }

  getSelectionData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/get-selection-data');
  }

  getVideoLinksData() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/get-video-links-data');
  }

  getYoutubePdfLinks() {
  //   if(!this.apiUrl) {
  //     this.setCustomFieldsData();
  //   }
  //  // return this.http.get(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
  //   return this.cacheAPI(this.apiUrl + 'api/get-video-pdf-data');

    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    data['start']=0;
    data['end']=1000;
    data['youtube_pdf']=1;
   return this.http.post(this.apiUrl + 'api/get-video-pdf-data', data);
  }

  getUserTestAttempts(userId, testId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.cacheAPI(this.apiUrl + 'api/get-user-series-attempted-count/'+ userId+'/'+testId);
  }


  getMarqueeText() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/avg-rank-data/'+series_id+'/'+this.customerId);
    return this.cacheAPI(this.apiUrl + 'api/get-marquee-data');
  }

  getPDFData() {
    return this.http.get(this.apiUrl + 'api/getAllPdfData/'+this.customerId);
  }

  purchasedNotes(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/user-notes/'+ userId);
    return this.cacheAPI(this.apiUrl + 'api/user-notes/'+ userId);
  }

  downloadNotesFile(notesName): any {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    const headers= new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');
	   return this.http.get(this.apiUrl + 'assets/pdf-notes/'+notesName, { 'headers': headers , responseType: 'blob'});
  }

  getUserPDFNotes(userId, notesId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
   // return this.http.get(this.apiUrl + 'api/get-user-pdf-notes/'+ userId+'/'+notesId);
    return this.cacheAPI(this.apiUrl + 'api/get-user-pdf-notes/'+ userId+'/'+notesId);
  }
  saveUserPDFNotes(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.post(this.apiUrl + 'api/save-user-pdf-notes', data);
  }

  getMenuLevelData() {
    return this.cacheAPI(this.apiUrl + 'api/master-category/'+ this.customerId);
  }

  getBooks(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    if(userId) {
      data['user_id'] = userId;
    }
    data['is_ebook']=1;
   return this.http.post(this.apiUrl + 'api/get-books-data', data);
  }

  getBookById(bookId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['book_id']=bookId;
    data['customer_id']=this.customerId;
   return this.http.post(this.apiUrl + 'api/get-books-details', data);
  }

  getAddresses(userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    data['user_id']=userId;
   return this.http.post(this.apiUrl + 'api/get-address', data);
  }

  getAddressById(addressId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['address_id']=addressId;
  //  data['customer_id']=this.customerId;
   return this.http.post(this.apiUrl + 'api/get-address-detail', data);
  }

  saveAddress(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']= this.customerId;
   return this.http.post(this.apiUrl + 'api/save-address', data);
  }

  deleteAddress(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']= this.customerId;
   return this.http.post(this.apiUrl + 'api/delete-address', data);
  }


  getCourseList(courseType) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/course/'+this.customerId+'/'+courseType);
   // return this.cacheAPI(this.apiUrl + 'api/course/'+this.customerId+'/'+courseType);
  }

  getCourseDetails(courseId, userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/getCourseData/'+courseId+'/'+userId);
   // return this.cacheAPI(this.apiUrl + 'api/getCourseData/'+courseId+'/'+userId);
  }

  getCourseSubscriptionDetails(courseId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/getSubscriptionByPackageId/'+this.customerId+'/'+courseId+'/course');
   // return this.cacheAPI(this.apiUrl + 'api/getSubscriptionByPackageId/'+this.customerId+'/'+courseId+'/course');
  }

  getClassesByCourseIds(courseIds) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data ={
      courseIds:courseIds
    }
    return this.http.post(this.apiUrl + 'api/getClassesByCourseIds', data);
  }

  getSyllabusByCourseIds(courseIds) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data ={
      courseIds:courseIds
    }
    return this.http.post(this.apiUrl + 'api/getSyllabusByCourseIds', data);
  }

  getCoursesByCourseIds(courseIds) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data ={
      courseIds:courseIds
    }
    return this.http.post(this.apiUrl + 'api/getCoursesByCourseIds', data);
  }

  getTodayLiveClasses(userId) {
    return this.http.get(this.apiUrl + 'api/getTodayLiveClass/'+userId+'/'+this.customerId);
  }

  getFreeVideos() {
    return this.http.get(this.apiUrl + 'api/getFreeVideos/'+this.customerId);
  }

  getMyCoursesVideos(user_id, type) {
    return this.http.get(this.apiUrl + 'api/get-my-course/'+user_id+"/"+this.customerId+"/"+type);
  }

  getCourseClassByTopic(courseId, userId) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    return this.http.get(this.apiUrl + 'api/getCourseDataByTopic/'+courseId+'/'+userId);
   // return this.cacheAPI(this.apiUrl + 'api/getCourseDataByTopic/'+courseId+'/'+userId);
  }

  getTodayQuizSeriesId(userId, date) {
    return this.http.get(this.apiUrl + 'api/getTodayLiveSeries/'+userId+'/'+date);
  }

  userlogout(userid) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data ={
      user_id:userid
    }
    data['customer_id']= this.customerId;
    return this.http.post(this.apiUrl + 'api/logout', data);
  }

  checkUserDeviceIpAddress(userId) {
    return this.http.get(this.apiUrl + 'api/checkUserApi/'+userId);
  }

  getPlanDetailById(subscriptionId) {
    // return this.http.get(this.apiUrl + 'api/get-plan-detail-by-id/'+subscriptionId);
    return this.cacheAPI(this.apiUrl + 'api/get-plan-detail-by-id/'+subscriptionId);
  }

  getPopularCoursesData() {
    // return this.http.get(this.apiUrl + 'api/get-plan-detail-by-id/'+subscriptionId);
    return this.cacheAPI(this.apiUrl + 'api/popular-courses');
  }

  getSections() {
    return this.http.get(this.apiUrl + 'api/getSections');
  }

  getAuthorsList() {
    return this.http.get(this.apiUrl + 'api/authors');
  }

  getGlobalSearchData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/global-search', data);
  }

  getBooksBySearch(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
   return this.http.post(this.apiUrl + 'api/getBooksBySearch', data);
  }


  getEmagazinesBooks(userId, catId='') {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    if(userId) {
      data['user_id'] = userId;
    }
    if(this.userData && this.userData.user_id) {
      data['user_id'] = this.userData.user_id;
    }
    if(catId) {
      data['main_category'] = catId;
    }
    data['is_ebook']=2;
   return this.http.post(this.apiUrl + 'api/get-books-data', data);
  }

  getPaperBooks(userId, catId='') {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    if(userId) {
      data['user_id'] = userId;
    }
    if(this.userData && this.userData.user_id) {
      data['user_id'] = this.userData.user_id;
    }
    if(catId) {
      data['main_category'] = catId;
    }
    data['is_ebook']=3;
   return this.http.post(this.apiUrl + 'api/get-books-data', data);
  }

  getEPaperBooks(userId, catId='') {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    var data={};
    data['customer_id']=this.customerId;
    if(userId) {
      data['user_id'] = userId;
    }
    if(this.userData && this.userData.user_id) {
      data['user_id'] = this.userData.user_id;
    }
    if(catId) {
      data['main_category'] = catId;
    }
    data['is_ebook']=4;
   return this.http.post(this.apiUrl + 'api/get-books-data', data);
  }

  getBooksByPublisher() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    // data['customer_id']=this.customerId;
   return this.http.get(this.apiUrl + 'api/publishers');
  }

  getOfferZone() {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    // data['customer_id']=this.customerId;
   return this.http.get(this.apiUrl + 'api/offer-zone');
  }

  getCartData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/get-cart', data); 
  }

  saveCartData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/add-cart', data); 
  }

  deleteCartData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/remove-cart', data); 
  }

  getCartDataMobile(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/v1/get-cart-mobile', data); 
  }

  addCartDataMobileBulk(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/v1/add-cart-bulk', data); 
  }

  saveCartDataMobile(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/v1/add-cart-mobile', data); 
  }

  updateCartDataMobile(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/v1/update-product-quantity', data); 
  }

  deleteCartDataMobile(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/v1/remove-cart-mobile', data); 
  }

  getBooksByPagination(userId, catId='', type='', data, extraFilter={}) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    if(userId) {
      data['user_id'] = userId;
    }
    if(this.userData && this.userData.user_id) {
      data['user_id'] = this.userData.user_id;
    }
    if(catId && type == 'main_cat' && catId != '0') {
      data['main_category'] = catId;
    }
    if(catId && type == 'author' && catId != '0') {
      data['author_id'] = catId;
    }
    if(catId && type == 'publisher' && catId != '0') {
      data['publisher_id'] = catId;
    }
    if(catId && type == 'section' && catId != '0') {
      data['section_id'] = catId;
    }
    if(extraFilter) {
      data = {...data, ...extraFilter};
    }
    if(!data['is_ebook']) {
      data['is_ebook']=0;
    }
   return this.http.post(this.apiUrl + 'api/get-books-data', data);
  }

  getBookReviewData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/get-review', data); 
  }

  addBookReviewData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    // data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/add-review', data); 
  }

  getAvgReviewData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    // data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/average-rating', data); 
  }

  getMyBookOrdersData(data) {
    if(!this.apiUrl) {
      this.setCustomFieldsData();
    }
    data['customer_id']=this.customerId;
    return this.http.post(this.apiUrl + 'api/my-book-orders', data); 
  }

  getDailyDosePlanDetail(userid) {
    return this.http.get(this.apiUrl + 'api/checkDailyDoseSubscription/'+userid);
    // return this.http.post(this.apiUrl + 'api/getBlogPdf', data);
  }

  getPDFGeneratorListing(clientName, date) {
    return this.http.get('https://www.hranker.com/admin/api/pdf-generator-title/' + clientName + '/' + date);
  }

}
